<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <form [formGroup]="passengerInfoForm" autocomplete="off">
    <div class="request-details">
      <mat-grid-list cols="2" rowHeight="66.5px" gutterSize="8px">
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <input matInput formControlName="name" placeholder="Name"required>
            <mat-error *ngIf="passengerInfoForm.get('name').invalid && passengerInfoForm.get('name').touched">
              Name is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <input matInput formControlName="nationality" placeholder="Nationality">
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <input matInput formControlName="passportNumber" placeholder="Passport">
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <input matInput formControlName="contactTelephoneNumber" placeholder="Telephone">
            <mat-error *ngIf="passengerInfoForm.get('contactTelephoneNumber').invalid && passengerInfoForm.get('contactTelephoneNumber').touched">
              Telphone Format is invalid.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput formControlName="contactEmail" placeholder="Email" required>
            <mat-error *ngIf="passengerInfoForm.get('contactEmail').invalid && passengerInfoForm.get('contactEmail').touched">
              Email is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="right-aligned-actions">
  <button mat-raised-button (click)="onCancel()" class="btn">Cancel</button>
  <button mat-raised-button (click)="onSubmit()" class="btn btn-primary">Save Changes</button>
</mat-dialog-actions>